import axios from 'axios'
import { MicroservicesBaseUrl } from '../../config'
import ReduxStore from '../redux/Store'
import { Start, Done } from '../redux/actions/PageLoadingActions'

const defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': MicroservicesBaseUrl.webBaseUrl,
}

export class ApiService {
    lastError
    timeoutInMs
    isAnonymous

    constructor(isAnonymous = false) {
        this.timeoutInMs = 60000
        this.isAnonymous = isAnonymous
    }

    restCall = async (
        microService,
        requestUrl,
        data,
        method,
        isShowProgressBar = true
    ) => {
        try {
            let self = this
            let API_URL = ''

            const headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': MicroservicesBaseUrl.webBaseUrl,
            }

            // Enable progress bar
            if (isShowProgressBar) {
                ReduxStore.dispatch({ type: Start })
            }

            switch (microService) {
                case 'IdentityAPI':
                    API_URL = MicroservicesBaseUrl.identityMicroServiceUrl
                    break
                case 'BaseAPI':
                    API_URL = MicroservicesBaseUrl.baseApiUrl
                    break
                case 'GenericAPI':
                    API_URL = MicroservicesBaseUrl.genericMicroserviceUrl
                    break
                default:
                    API_URL = MicroservicesBaseUrl.baseApiUrl
                    break
            }

            if (!self.isAnonymous) {
            } else {
                return new Promise((resolve, reject) => {
                    let url = API_URL + requestUrl
                    const request = {
                        method: method || 'GET',
                        headers: headers,
                        url: url,
                    }
                    if (method === 'get') {
                        request['params'] = data || {}
                    } else {
                        request['data'] = data || {}
                    }
                    axios(request)
                        .then((response) => {
                            if (isShowProgressBar) {
                                ReduxStore.dispatch({ type: Done })
                            }
                            resolve(response)
                        })
                        .catch((error) => {
                            reject(error)
                        })
                        .finally(() => {
                            if (isShowProgressBar) {
                                ReduxStore.dispatch({ type: Done })
                            }
                        })
                })
            }
        } catch (error) {
            if (isShowProgressBar) {
                ReduxStore.dispatch({ type: Done })
            }
            return Promise.reject(error)
        }
    }
}

export const apiService = new ApiService()
